export default __webpack_public_path__ + "static/media/text-landscape.2c565ed6.svg";